import { Block, Tag } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import mezoLogo from "#/assets/mezo-lockup.svg"
import {
  ENABLE_SEPARATE_MEZO_CHAINS,
  IS_MEZO_MAINNET,
  MAINNET_BANNER_HEIGHT,
  routes,
  SIDEBAR_NAVIGATION_WIDTH,
} from "#/shared/constants"

import SidebarNavigationHelp from "./SidebarNavigationHelp"
import SidebarNavigationItemList from "./SidebarNavigationItemList"
import SidebarNavigationMezoChainInfo from "./SidebarNavigationMezoChainInfo"

export default function SidebarNavigation() {
  return (
    <Block
      padding="32px 0"
      top={0}
      width={SIDEBAR_NAVIGATION_WIDTH}
      position="sticky"
      backgroundColor="white"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      maxHeight={`calc(100vh - ${MAINNET_BANNER_HEIGHT}px)`}
    >
      <Block marginBottom="40px">
        <Block
          display="flex"
          alignItems="center"
          paddingLeft="12px"
          paddingRight="12px"
          marginBottom="60px"
          overrides={{
            Block: {
              style: { gap: "12px" },
            },
          }}
        >
          <Link to={routes.LANDING}>
            <Block as="img" src={mezoLogo} alt="Mezo" />
          </Link>

          {ENABLE_SEPARATE_MEZO_CHAINS && !IS_MEZO_MAINNET && (
            <Tag
              closeable={false}
              color="yellow"
              size="small"
              overrides={{
                Root: {
                  style: { margin: 0 },
                },
              }}
            >
              Testnet
            </Tag>
          )}
        </Block>
        <SidebarNavigationItemList />
      </Block>
      <Block padding="0 14px">
        <SidebarNavigationMezoChainInfo />
        <SidebarNavigationHelp />
      </Block>
    </Block>
  )
}
